<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">

      <b-tab :title="lang.tab_Details" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">
        
        <ProjectDetailsComponent :lang="lang.ProjectDetails"></ProjectDetailsComponent>


      </b-tab>

      <b-tab :title="lang.tab_BOMs" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 1">

        
        <BomsProjectTableComponent :lang="lang.BomsTable"></BomsProjectTableComponent>


        <!-- <br><br><p>{{lang.infotext_2}}:</p>
        <VariantsComponent :lang="lang.Variants"></VariantsComponent> -->
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_BomComparison" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 2">
        
        <BomComparisonComponent :lang="lang.BomComparison"></BomComparisonComponent>
        <BomComparisonForRevisionsComponent :lang="lang.BomComparison"></BomComparisonForRevisionsComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_ProjectSpec" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 3">
        
        <ProjectSpecComponent :lang="lang.ProjectSpec"></ProjectSpecComponent>

      </b-tab>
      <!-- <b-tab :title="lang.tab_Variants"  :title-link-class="textColors" :title-item-class="textColors" >
        <p>{{lang.infotext_2}}:</p>
        
      </b-tab> -->
      <!-- <b-tab :title="lang.tab_IPC"  :title-link-class="textColors" :title-item-class="textColors" >
        <p>{{lang.infotext_4}}:</p>
        
      </b-tab> -->

    </b-tabs>

  </div>

</template>
<script>

import { mapGetters } from 'vuex'
import ProjectDetailsComponent from '@/components/shared/ProjectDetailsComponent'
import FoldersTreeComponent from '@/components/shared/FoldersTreeComponent'
import BomsProjectTableComponent from '@/components/shared/BomsProjectTableComponent'
// import VariantsComponent from '@/components/shared/VariantsComponent'
import BomComparisonComponent from '@/components/shared/BomComparisonComponent'
import BomComparisonForRevisionsComponent from '@/components/shared/BomComparisonForRevisionsComponent'
import ProjectSpecComponent from '@/components/shared/ProjectSpecComponent'

export default {
  name: "Content",
  components: {
    ProjectDetailsComponent,
    FoldersTreeComponent,
    BomsProjectTableComponent,
    // VariantsComponent,
    BomComparisonComponent,
    BomComparisonForRevisionsComponent,
    ProjectSpecComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,
      
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      appConf: 'appConf',
    }),
    
    isAssembly(){
      return false;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    

  },
  created() {
    this.getTabIndex();
    

  },
  
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;
        
      this.$store.commit("SETTABDATA", obj);

      //####################
      
      
      this.$parent.$parent.$parent.switchButtons(newVal);

      if (newVal == 0) {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
      }
      if (newVal == 1) {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
        const reloadObj = {
          status: true,
          name: "BomComparisonComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      }
      if (newVal == 2) {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
        const reloadObj = {
          status: true,
          name: "BomsProjectTableComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      }
    },
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
  },
}
</script>

<style scooped>

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDetails/Middle/Content/Content.vue